import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets window scroll when the route path changes. Hash-only changes on the
 * same path are ignored so in-page anchors (e.g. /#products) still work.
 */
export function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, search]);

  return null;
}
